export function updateStep3Action(
  state: any,
  payload: {
    qualifications: any;
    skills: any;
    progressStep: any;
  }
) {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  };
}
